/** Emails that can be sent to the client again. Mail that only tells the studio can be previewed, not resent. */
const RESENDABLE_NOTICES = new Set([
  'quotation-issued',
  'quotation-follow-up',
  'booking-secured',
  'shoot-confirmed',
  'booking-updated',
  'shoot-reminder',
  'deposit-reminder',
  'balance-requested',
  'payment-received',
  'paid-in-full',
  'photos-delivered',
  'studio-reply',
]);

export function canResendClientNotice(type?: string) {
  return RESENDABLE_NOTICES.has(String(type || ''));
}
